import { ArticleFilterQueryParams, ArticleSearchResultResponse, MainEndpoints } from "@authory-packages/core";
import axios from "axios";
import { API_URL, withUserSlug } from ".";
import { getHeaders } from "./get-headers";

export const getUserContent = async (token: string | null, userSlug: string | undefined, params: ArticleFilterQueryParams) => {
    const { data } = await axios.get<ArticleSearchResultResponse>(`${API_URL}${withUserSlug(MainEndpoints.UserArticles, userSlug || "")}`, {
        params,
        ...getHeaders(token || "")
    });

    return data;
};
